export default __webpack_public_path__ + "bf377574059ac5dd30c39ef2247b0835.svg";